export default "__VITE_ASSET__DrQRPV78__"